// app/(main)/conditions/page.tsx
import { PageContainer } from "@/components/ui/PageContainer";

export default function ConditionsPage() {
  return (
    <PageContainer withContainer>
      <div className="py-8 md:py-12 max-w-4xl mx-auto">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
          Conditions générales de vente
        </h1>
        
        <div className="space-y-6 text-gray-600">
          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">1. Objet</h2>
            <p>
              Les présentes conditions générales de vente régissent les relations entre Cabukaka 
              et ses clients dans le cadre de la vente de produits sur la plateforme.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">2. Prix</h2>
            <p>
              Les prix sont indiqués en FCFA toutes taxes comprises. Cabukaka se réserve le droit 
              de modifier ses prix à tout moment.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">3. Commande</h2>
            <p>
              Toute commande vaut acceptation des prix et description des produits disponibles 
              à la vente. Cabukaka s'engage à honorer les commandes dans la limite des stocks.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">4. Paiement</h2>
            <p>
              Le paiement s'effectue par carte bancaire, Mobile Money ou virement bancaire. 
              La commande est confirmée après validation du paiement.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">5. Livraison</h2>
            <p>
              La livraison est assurée à Douala, Yaoundé et dans les principales villes du Cameroun. 
              Les délais de livraison sont indiqués lors de la commande.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">6. Droit de rétractation</h2>
            <p>
              Conformément à la législation en vigueur, le client dispose d'un délai de 14 jours 
              pour exercer son droit de rétractation sans avoir à justifier de motifs.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">7. Garantie</h2>
            <p>
              Tous les produits bénéficient de la garantie légale de conformité et des vices cachés.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-3">8. Contact</h2>
            <p>
              Pour toute question, contactez-nous à contact@cabukaka.com ou au +237 6 XX XX XX XX.
            </p>
          </section>

          <div className="bg-gray-50 p-4 rounded-lg mt-8">
            <p className="text-sm text-gray-500">
              Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
            </p>
          </div>
        </div>
      </div>
    </PageContainer>
  );
}